'use strict';
'use es6';

// Shallow copy all values from sources to target
// @See https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectAssign = objectAssign;
exports.defaults = defaults;
function objectAssign(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    var descriptors = Object.keys(source).reduce(function (descriptors, key) {
      descriptors[key] = Object.getOwnPropertyDescriptor(source, key);
      return descriptors;
    }, {});
    Object.defineProperties(target, descriptors);
  });
  return target;
};

// Create a new object with all values from sources
// This method reads from left to right, so that defaults({ a: 1 }, { b: 2 }, { a: 3, b: 4, c: 5 })
// produces { a: 1, b: 2, c: 5 }
function defaults() {
  for (var _len2 = arguments.length, sources = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    sources[_key2] = arguments[_key2];
  }

  if (sources.length === 0) {
    return undefined;
  }

  var clone = objectAssign({}, sources[0]);

  if (sources.length === 1) {
    return clone;
  }

  var _loop = function _loop(i) {
    var source = sources[i];

    var descriptors = Object.keys(source).reduce(function (descriptors, key) {
      if (typeof clone[key] === 'undefined') {
        descriptors[key] = Object.getOwnPropertyDescriptor(source, key);
      }
      return descriptors;
    }, {});

    Object.defineProperties(clone, descriptors);
  };

  for (var i = 1; i < sources.length; i++) {
    _loop(i);
  }

  return clone;
};